<template>
  <v-navigation-drawer
    v-model="leftDrawer.opened"
    :mini-variant="leftDrawer.miniVariant"
    :clipped="leftDrawer.clipped"
    :width="this.$vuetify.breakpoint.smAndDown ? '100%' : 350"
    fixed
    class="mainNavBar"
    v-bind="
      leftDrawer.opened && leftDrawer.permanent ? { permanent: true } : {}
    "
    floating
    app
  >
    <div class="app-sidebar white--text">
      <header
        class="app-sidebar-header text-center d-flex justify-space-between d-md-block"
      >
        <router-link :to="{ name: 'dashboard' }" class="site-logo">
          <img src="@assets/images/app-logo1@2x.png" alt />
        </router-link>
        <a
          href="javascript:void(0);"
          @click="leftDrawer.opened = false"
          class="close"
        ></a>
      </header>
      <p>
        <a href="javascript:void(0)" id="translator"></a>
      </p>
      <div id="google_translate_element"></div>
      <section class="app-sidebar-navigation px-8 pb-8">
        <v-list dark rounded class="pa-0 transparent mb-10 ">
          <v-list-item
            :to="{ name: 'dashboard' }"
            class="border-radius-14"
            v-if="user.id && isOnLine"
          >
            <v-list-item-icon>
              <v-icon>$dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="title font-weight-bold letter-spacing-normal"
              >
                Dashboard
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(page, index) in permittedPages"
            class="border-radius-14"
            :key="index"
            :to="{ name: page.routeName }"
          >
            <v-list-item-icon>
              <v-icon>{{ page.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="title  font-weight-bold letter-spacing-normal"
              >
                {{ page.label || page.routeName.capitalize() }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card rounded class="card--guidelines pa-2">
          <v-card-title class="font-weight-bold mb-n1">Guidelines</v-card-title>
          <v-card-text class="mb-n2 letter-spacing-normal">
            Learn how to make the most out of our software and services
          </v-card-text>
          <v-card-text class="d-flex justify-center">
            <a
              target="_blank"
              href="https://www.notion.so/Guides-Tutorials-418bf91efca24986b6fa4fe9a7d60ae9"
              class="btn-text-primary font-weight-bold v-btn v-btn--depressed theme--light v-size--default"
            >
              Learn More
            </a>
          </v-card-text>
        </v-card>
      </section>
      <footer class="app-sidebar-footer text-center pa-6">
        <v-btn
          depressed
          text
          class="white--text"
          title="Logout"
          @click="logout()"
        >
          <v-icon>$logout</v-icon>
        </v-btn>
      </footer>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';
import { throttle } from 'lodash';
import Storage from '@services/Storage';
import { StoreNames } from '@constants/storage';
import { isOnline } from '@helpers';

const storage = new Storage();

const offlineRoute = {
  routeName: 'offline-trips',
  icon: '$groupOutline',
  action: 'read',
  entity: 'offline-trips',
  label: 'Offline Trips',
};

export default {
  name: 'AppLeftBar',
  data() {
    return {
      pages: [
        {
          routeName: 'groups',
          icon: '$group',
          action: 'read',
          entity: 'groups',
        },
        {
          routeName: 'custom-trips',
          icon: '$groupOutline',
          action: 'read',
          entity: 'custom-trips',
          label: 'My Trips',
        },
        {
          routeName: 'tours',
          icon: '$map',
          action: 'read',
          entity: 'tours',
        },
        {
          routeName: 'species-family',
          icon: '$fishFamily',
          action: 'read',
          label: 'Family',
          entity: 'species-family',
        },
        {
          routeName: 'species',
          icon: '$fish',
          action: 'read',
          entity: 'species',
        },
        {
          routeName: 'operators',
          icon: '$users',
          action: 'read',
          entity: 'operators',
        },
        {
          routeName: 'projects',
          icon: '$clipboard',
          action: 'read',
          entity: 'projects',
        },
        {
          routeName: 'managers',
          icon: '$users',
          action: 'read',
          entity: 'managers',
          label: 'Communities',
        },
        {
          routeName: 'payments',
          icon: '$visa',
          action: 'read',
          entity: 'payments',
          label: 'Payment Log',
        },
      ],
      offlineUser: null,
    };
  },
  computed: {
    ...mapState('auth', {
      user: 'user',
      isOnLine: 'isOnLine',
    }),
    permittedPages() {
      let self = this;

      if (
        (!self.isOnLine &&
          self.offlineUser &&
          self.offlineUser.role === 'tourist') ||
        !localStorage.getItem('x-access-token')
      ) {
        return [offlineRoute];
      }

      const pages = self.pages.filter((page) => {
        if (self.user.role === 'tourist' && page.routeName === 'groups') {
          page.label = `Operator's Trips`;
        }
        return (
          !page.action ||
          (self.user.can &&
            self.user.can(page.action, page.entity || page.routeName))
        );
      });

      if (self.offlineUser && self.offlineUser.role === 'tourist') {
        let hasOfflineTrips = self.pages.indexOf('offline-trips');
        if (hasOfflineTrips < 0) {
          let index = self.pages.findIndex(
            (route) => route.routeName === 'custom-trips'
          );
          pages.splice(index + 1, 0, offlineRoute);
        }
      }
      return pages;
    },
  },
  methods: {
    logout() {
      $logout();
    },
    makeResponsive() {
      if (this.leftDrawer.manuallySwitched) {
        return;
      }
      this.leftDrawer.opened = !this.$vuetify.breakpoint.smAndDown;
    },
  },
  async mounted() {
    if (isOnline()) {
      await this.$nextTick(() => {
        let targetID = 'translator';
        if (window.googleTranslatorDiv) {
          document.getElementById(targetID).append(window.googleTranslatorDiv);
          return;
        }
        if (
          document.getElementById('translator') &&
          !window.googleTranslateElementInit
        ) {
          const intervalTranslate = setInterval(() => {
            if (google.translate.TranslateElement !== undefined) {
              window.googleTranslateElementInit = function() {
                window.googleTranslator = new google.translate.TranslateElement(
                  { pageLanguage: 'en' },
                  targetID
                );
              };
              window.googleTranslateElementInit();
              window.googleTranslatorDiv = document.getElementById(
                targetID
              ).children[0];
              clearInterval(intervalTranslate);
            }
          }, 100);
        }
      });
    }
    this.makeResponsive();
    window.addEventListener('resize', throttle(this.makeResponsive, 100));

    this.offlineUser = await storage.findFirst(StoreNames.USERS);
  },
};
</script>

<style lang="scss">
.app-sidebar-navigation {
  scrollbar-base-color: transparent;
  scrollbar-color: rgba(123, 135, 142, 0.7) transparent !important;
  scrollbar-width: thin !important;

  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
}

.goog-te-combo {
  color: black;
  background-color: white;
  border-radius: 10px;
  padding: 1px 61px 1px 64px;
}

.goog-te-gadget {
  font-size: 11px;
  color: #fff;
  white-space: nowrap;
  padding: 0 0 0 35px;
}

.goog-logo-link,
.goog-logo-link:link,
.goog-logo-link:visited,
.goog-logo-link:hover,
.goog-logo-link:active {
  color: #fff;
  text-decoration: none;
  font-weight: normal;
  font-size: 11px;
}
</style>
